import { MapPin, Clock, Phone, Truck } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { OpenBadge } from "./OpenBadge";
import { CONTACT } from "../lib/menuData";

const Info = ({ icon: Icon, title, children }) => (
  <div className="flex gap-4">
    <div className="mt-1 h-10 w-10 shrink-0 rounded-full border border-gold/30 flex items-center justify-center text-gold">
      <Icon size={18} />
    </div>
    <div>
      <div className="overline mb-1">{title}</div>
      <div className="text-cream/85 leading-relaxed">{children}</div>
    </div>
  </div>
);

export const Location = () => (
  <section id="location" className="relative bg-teal py-24 md:py-36 grain">
    <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-10">
      <div className="flex items-center justify-between flex-wrap gap-4 mb-16">
        <Overline>Kapitel IV — Location & Abholung</Overline>
        <Reveal><span className="font-serif text-8xl md:text-9xl text-gold/10 leading-none select-none">IV</span></Reveal>
      </div>

      <div className="grid lg:grid-cols-2 gap-14 items-start">
        <div>
          <Reveal>
            <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl text-cream leading-tight">
              Mitten in <span className="italic text-gold">Karlsruhe</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-cream/70 max-w-md leading-relaxed">
              Besuche uns zur Abholung in der Wilhelmstraße 43 – oder wir liefern
              direkt zu dir nach Hause (ab 20 € Mindestbestellwert). Online bestellt
              sparst du immer 10 %.
            </p>
          </Reveal>
          <div className="mt-10 space-y-7">
            <Reveal delay={0.14}><Info icon={MapPin} title="Adresse">Wilhelmstraße 43<br />76137 Karlsruhe</Info></Reveal>
            <Reveal delay={0.2}><Info icon={Clock} title="Öffnungszeiten">Mo – Sa: 16:00 – 02:00 Uhr<br />So: 12:00 – 01:00 Uhr<br /><span className="inline-block mt-3"><OpenBadge /></span></Info></Reveal>
            <Reveal delay={0.26}>
              <Info icon={Phone} title="Bestellen">
                <a href={CONTACT.phoneHref} className="link-underline text-gold-light">{CONTACT.phone}</a>
                <br /><span className="text-cream/55 text-sm">{CONTACT.website}</span>
              </Info>
            </Reveal>
          </div>
          <Reveal delay={0.3}>
            <a href="#speisekarte" data-testid="location-order-btn"
              className="inline-block mt-10 bg-gold text-teal-dark px-7 py-3.5 rounded-full font-medium hover:bg-gold-light transition-colors">
              Zur Abholbestellung
            </a>
          </Reveal>
        </div>

        <div className="space-y-6">
          <Reveal delay={0.15}>
            <div className="overflow-hidden rounded-sm border border-gold/25 h-[300px] md:h-[340px]">
              <iframe
                title="Standort Ceylon Royal Kitchen"
                data-testid="location-map"
                src="https://www.google.com/maps?q=Wilhelmstra%C3%9Fe%2043%2C%2076137%20Karlsruhe&output=embed"
                className="h-full w-full"
                style={{ border: 0, filter: "grayscale(30%) sepia(25%) hue-rotate(120deg) saturate(1.2) brightness(0.95)" }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </Reveal>
          <Reveal delay={0.22}>
            <div className="border border-gold/20 rounded-sm p-6 bg-teal-deep">
              <div className="flex items-center gap-2 overline mb-4"><Truck size={15} /> Lieferung</div>
              <p className="text-cream/70 text-sm leading-relaxed">
                Wir liefern direkt zu dir nach Hause (ab 20 € Mindestbestellwert) – oder du bestellst über unsere Partner:
              </p>
              <div className="mt-4 flex flex-wrap gap-3">
                <span data-testid="partner-ubereats"
                  className="px-5 py-2.5 rounded-full border border-gold/40 text-gold-light font-medium text-sm tracking-wide">
                  Uber Eats
                </span>
                <span data-testid="partner-lieferando"
                  className="px-5 py-2.5 rounded-full border border-gold/40 text-gold-light font-medium text-sm tracking-wide">
                  Lieferando
                </span>
              </div>
              <p className="text-cream/50 text-xs mt-5 leading-relaxed">
                Direkt bei uns bestellen lohnt sich: Auf alle Online-Bestellungen über unsere Website gibt es 10 % Rabatt.
              </p>
              <p className="text-cream/40 text-[0.7rem] mt-3 leading-relaxed" data-testid="delivery-zones">
                Wir liefern nach: 76131 · 76133 · 76135 · 76137 · 76139 · 76149 · 76185 · 76187 · 76189 · 76199 · 76227 · 76228 · 76229 · 76275
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
